import React, {Component} from 'react';
import ReferencesWeeklyDigest from './references_weekly_digest'
import Markdown from './markdown'

export default class ReferencesWeeklyDigestAI extends ReferencesWeeklyDigest {

  renderReference(reference) {
    
    let alert_icon;
    if (reference.reference_year !== new Date().getFullYear()) {
      alert_icon = <span className="fa-solid fa-triangle-exclamation" />
    }
    return (
      <>
        <div className="reference" key={reference.reference_id}>
          <div className="summary">
            <Markdown text={reference.summary} />
          </div>
          <p>🔗 {reference.source_link} {alert_icon}</p>
        </div>
        <hr/>
      </>
    )
  }

  renderTrialsGroup(name, trials) {
    if (!trials || trials.length === 0) return null;
    let all_trials = [];
    for (let i=0; i < trials.length; i++) {
      let trial = trials[i];
      all_trials.push(this.renderTrial(trial));
      all_trials.push(<hr key={'hr_' + trial.trial_id} />);
    }
    return (
      <div key={name}>
        <h3>{name}</h3>
        <hr/>
        {all_trials}
      </div>
    )
  }


  renderTrial(trial) {
    let alert_icon;
    if (trial.created_at_year && trial.created_at_year !== new Date().getFullYear()) {
      alert_icon = <span className="fa-solid fa-triangle-exclamation" />
    }

    return (
      <>
        <div className="trial" key={trial.trial_id}>
          <div className="summary">
            <Markdown text={trial.summary} />
          </div>
          <p> | <a href={trial.study_url} target="_blank">{trial.identifier}</a> {alert_icon}</p>
        </div>
        <hr/>
      </>
    )
  }
}
